import PowerSelectBeforeOptions from 'ember-power-select/components/power-select/before-options';
export default class PowerSelectCustomsSearch extends PowerSelectBeforeOptions {}